// /apps — real route (design doc's G2). apps/web's app/apps/page.tsx had no
// separate client component to alias-mount (an async server component doing
// `await listBuiltApps({ userId })`, a direct DB read, inline at render
// time), so this was rewritten as a real client component
// (apps/spa/app/apps/page.tsx) fetching a NEW `GET /api/apps` endpoint
// (apps/server/src/routes/apps.ts, mounted in app.ts) that reuses
// `listBuiltApps` (packages/core/lib/built-apps.ts) unchanged — same
// pattern routes/connections-page.tsx used for /connections. Registered
// into the route tree from routes/agents.tsx under the `_authed` guard.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { authedRoute } from './guards';

const AppsPage = lazy(() => import('@/app/apps/page'));

export const appsPageRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: '/apps',
  component: AppsPage,
});
